module.exports = __webpack_public_path__ + "static/img/08-01.2efa9ecc.png";